import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { DataService } from '../../services/data.service';
import { UserDocument } from '../../interfaces/user-document.interface';

interface Crumb { label: string; route?: string; }

const ROUTE_META: Record<string, { title: string; parent?: string }> = {
  '/':                  { title: 'Dashboard',             parent: 'Tổng quan' },
  '/orgs':              { title: 'Tổ chức & xác minh',   parent: 'Tổ chức & người dùng' },
  '/users':             { title: 'Người dùng',            parent: 'Tổ chức & người dùng' },
  '/service-management':{ title: 'Danh mục chuẩn',       parent: 'Tổ chức & người dùng' },
  '/price-editor':      { title: 'Cấu hình kinh tế',     parent: 'Tiền & đối soát' },
  '/ledger':            { title: 'Sổ cái',                parent: 'Tiền & đối soát' },
  '/settle':            { title: 'Đối soát kỳ',           parent: 'Tiền & đối soát' },
  '/payment-center':    { title: 'Rút tiền & chi trả',   parent: 'Tiền & đối soát' },
  '/controlCenter':     { title: 'Kiểm duyệt cộng đồng', parent: 'Nội dung & hỗ trợ' },
  '/tickets':           { title: 'Khiếu nại & hỗ trợ',  parent: 'Nội dung & hỗ trợ' },
  '/ai-settings':       { title: 'AI & Prompt',           parent: 'Tăng trưởng' },
  '/campaigns':         { title: 'Chiến dịch',            parent: 'Tăng trưởng' },
  '/roles':             { title: 'Vai trò nền tảng',      parent: 'Hệ thống' },
  '/audit':             { title: 'Nhật ký quản trị',      parent: 'Hệ thống' },
  '/food-management':   { title: 'Quản lý món ăn',        parent: 'Tổ chức & người dùng' },
  '/mission-management':{ title: 'Quản lý nhiệm vụ',     parent: 'Tổ chức & người dùng' },
  '/ad-management':     { title: 'Quảng cáo',             parent: 'Tổ chức & người dùng' },
};

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule]
})
export class TopbarComponent implements OnInit, OnDestroy {
  crumbs: Crumb[] = [];
  pageTitle = 'Dashboard';
  userData: UserDocument | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.buildCrumbs(this.router.url);

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((e: any) => {
      this.buildCrumbs(e.urlAfterRedirects);
    });

    this.dataService.userData$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(u => this.userData = u);
  }

  private buildCrumbs(url: string): void {
    const base = url.split('?')[0].split('#')[0];
    const meta = ROUTE_META[base];

    if (!meta) {
      this.pageTitle = 'Quản trị tổng';
      this.crumbs = [{ label: 'Quản trị tổng' }];
      return;
    }

    this.pageTitle = meta.title;
    this.crumbs = [
      { label: 'Quản trị tổng', route: '/' },
      ...(meta.parent ? [{ label: meta.parent }] : []),
      { label: meta.title }
    ];
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
